module.exports = __webpack_public_path__ + "img/home-active.6a08f1a8.svg";